const DepartmentEnums = {
  RH: 'RH',
  TI: 'TI',
  SAC: 'SAC',
  FINANCEIRO: 'Financeiro',
  COMERCIAL: 'Comercial',
  LOGISTICA: 'Logística',
  ALMOXARIFADO: 'Almoxarifado',
  DIRETORIA: 'Diretoria',
  MARKETING: 'Marketing',
  JURIDICO: 'Jurídico',
  QUALIDADE: 'Qualidade',
  MANUTENCAO: 'Manutenção',
  EXPEDICAO: 'Expedição',

}

export default DepartmentEnums